import { render } from "./CircunferenciaComponent.vue?vue&type=template&id=0d7cded7&scoped=true"
import script from "./CircunferenciaComponent.vue?vue&type=script&lang=js"
export * from "./CircunferenciaComponent.vue?vue&type=script&lang=js"

import "./CircunferenciaComponent.vue?vue&type=style&index=0&id=0d7cded7&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7cded7"]])

export default __exports__